import "../10. Battle/Library/LibraryBoxBattle.scss";
import "./BattleStatisticsDialog.scss";
import NP from "../1. Core/NP";
import Label from "../1. Core/Controls/Label/Label";
import Button from "../1. Core/Controls/Button/Button";
import {ServerAPI} from "../1. Core/ServerAPI";
import CheckBox from "../1. Core/Controls/CheckBox/CheckBox";
import Dialog, {DialogCloseEventArgs} from "../1. Core/Controls/Dialog/Dialog";
import Control from "../1. Core/Control";
import TimeEdit, {TimeEditMode} from "../1. Core/Controls/TimeEdit/TimeEdit";
import {IUserInfo} from "../1. Core/UserInfo";
import UserInfo from "../1. Core/UserInfo";
import {IBattle, MMAEvent} from "../10. Battle/types";


/**
 * Старый диалог ввода данных по ударам в MMA поединке
 */
export default class MMAStatDialog extends Dialog {

	protected _CheckEditLockTimer: number;

	private _Battle: IBattle;
	private _TournamentId: number;
	private _MaxRound: number;
	private _Tournament: string;


	private _LastEditedRound: number;


	private _LastEditedTimeSegmentIndex: number;


	private _CurrentBattleEvents: MMAEvent[];

	private _historyNode: HTMLElement;


	private _redLabel: Label;
	private _blueLabel: Label;
	private _roundLabel: Label;


	private _nextRoundBtn: Button;
	private _boutEndBtn: Button;


	private _strikeRed: HTMLElement;
	private _strikeBlue: HTMLElement;
	private _screen2Red: HTMLElement;
	private _screen2Blue: HTMLElement;
	private _screen3Red: HTMLElement;
	private _screen3Blue: HTMLElement;
	private _answerRed: HTMLElement;
	private _answerBlue: HTMLElement;

	_strikeRedButtons: Button[];
	_strikeBlueButtons: Button[];
	_answerRedButtons: Button[];
	_answerBlueButtons: Button[];

	_screen2RedButtons: Control[];
	_screen2BlueButtons: Control[];

	_screen3RedButtons: Control[];
	_screen3BlueButtons: Control[];


	private _CurrentEvent: MMAEvent;
	private _GroundStart: string;
	private _GroundEnd: string;
	private _GrappleStart: string;
	private _GrappleEnd: string;
	private _Round: number;
	private _CurrentTime: string;
	private _exitGroundBtn: Button;
	private _exitGrappleBtn: Button;
	private _canNextRound: boolean;
	private _removeLastEvBtn: Button;
	private _saveBtn: Button;
	private _canceleBtn: Button;
	private _lastHistoryEvent: MMAEvent;


	_initFields(settings: object)
	{
		this._CheckEditLockTimer = null;

		this._CurrentBattleEvents = [];

		this._Tournament = '';
		this._TournamentId = 0;
		this._Round = 1;
		this._LastEditedRound = 1;
		this._Battle = null;
		this._LastEditedTimeSegmentIndex = 0;

		super._initFields(settings);
		this._CurrentTime = '00:00';
		this._Mode = 'FullHeight';
		this._Width = 650;
		this._Caption = "MMA Stat";
		this._CloseOnFrameMouseDown = false;
		this._ShowHeader = true;
		this._ShowCloseButton = true;
		this._ShowButtons = false;
		this._UseSinglePaddingContent = false;
		this._FlexContent = true;
		this._MaxRound = this._TournamentId < 0 ? 12 : 3;
	}

	_render()
	{
		super._render();
		this.addClass('nopad battle-statistics-dialog mma-stat-dialog');

		let boutInfoNode = NP.createNode(this._contentNode, 'bout-info');


		let boutInfoNodeSecondRow = NP.createNode(boutInfoNode, 'bout-info__row');
		this._redLabel = new Label({
			ParentNode: boutInfoNodeSecondRow,
			Class: 'bout-info__row__item bout-info__row__item__red',
			MultiLine: true,
			Content: this._Battle.RedName
		});
		this._blueLabel = new Label({
			ParentNode: boutInfoNodeSecondRow,
			Class: 'bout-info__row__item bout-info__row__item__blue',
			MultiLine: true,
			Content: this._Battle.BlueName
		});

		let roundParent = NP.createNode(boutInfoNode, 'bout-info__row');
		this._roundLabel = new Label({
			ParentNode: roundParent,
			Class: 'bout-info__row__item',
		});

		this._exitGroundBtn = new Button({
			ParentNode: roundParent,
			Class: 'bout-info__row__item',
			RK: 'ExitFromGround',
			IsVisible: false,
			EvClick: () => this.endGroundAndGrapple()
		});


		let eventInfoNode = NP.createNode(this._contentNode, 'event-info');
		let eventInfoLeftSection = NP.createNode(eventInfoNode, 'event-info__section event-info__section__red');
		let eventInfoRightSection = NP.createNode(eventInfoNode, 'event-info__section event-info__section__blue');


		//punches, screen 1
		this._strikeRed = NP.createNode(eventInfoLeftSection, 'event-info__actions');
		this._strikeRedButtons = this.createPunches(this._strikeRed);

		this._strikeBlue = NP.createNode(eventInfoRightSection, 'event-info__actions');
		this._strikeBlueButtons = this.createPunches(this._strikeBlue);

		//screen 2
		this._screen2Red = NP.createNode(eventInfoLeftSection, 'event-info__actions');
		this._screen2RedButtons = this.createScreen2Buttons(this._screen2Red);

		this._screen2Blue = NP.createNode(eventInfoRightSection, 'event-info__actions');
		this._screen2BlueButtons = this.createScreen2Buttons(this._screen2Blue);

		//success, Unsuccessfully - screen 3
		this._screen3Red = NP.createNode(eventInfoLeftSection, 'event-info__actions');
		this._screen3RedButtons = this.createScreen3Buttons(this._screen3Red);

		this._screen3Blue = NP.createNode(eventInfoRightSection, 'event-info__actions');
		this._screen3BlueButtons = this.createScreen3Buttons(this._screen3Blue);

		//answers, screen4
		this._answerRed = NP.createNode(eventInfoLeftSection, 'event-info__actions');
		this._answerRedButtons = this.createAnswers(this._answerRed);

		this._answerBlue = NP.createNode(eventInfoRightSection, 'event-info__actions');
		this._answerBlueButtons = this.createAnswers(this._answerBlue);


		let actionButtonsNode = NP.createNode(this._contentNode, 'action-buttons');

		this._saveBtn = new Button({
			RK: 'Space',
			Class: 'action-buttons__btn',
			ParentNode: actionButtonsNode,
			EvClick: () =>
			{
				if (!this._GrappleStart && !this._GroundStart)
				{
					if (this._CurrentBattleEvents.length)
					{
						this.saveCurrentEvents();
						let node = NP.createNode(this._historyNode, 'events-history__row', null);
						node.setAttribute('is_temp', 'true');
						node.innerText = '--Space--';
						this._historyNode.scrollTop = this._historyNode.scrollHeight;
					}
					else
						NP.showMessage({Content: 'Всё сохранено'});
				}
				else
					NP.showMessage({Content: 'Надо закончить захват или партер'});
			}
		});

		this._removeLastEvBtn = new Button({
			RK: 'RemoveLastEvent',
			IsVisible: false,
			ParentNode: actionButtonsNode,
			Class: 'action-buttons__btn',
			EvClick: () => this.removeLastEvent()
		});

		this._nextRoundBtn = new Button({
			RK: 'NextRound',
			ParentNode: actionButtonsNode,
			Class: 'action-buttons__btn',
			EvClick: () => this._setNextRound()
		});
		this._boutEndBtn = new Button({
			RK: 'BoutEnd',
			ParentNode: actionButtonsNode,
			Class: 'action-buttons__btn',
			EvClick: () => this._setBoutEnd()
		});

		this._exitGrappleBtn = new Button({
			ParentNode: actionButtonsNode,
			Class: 'action-buttons__btn',
			RK: 'ExitFromControl',
			IsVisible: false,
			EvClick: () => this.endControl()
		});

		this._canceleBtn = new Button({
			ParentNode: actionButtonsNode,
			Class: 'action-buttons__btn',
			RK: 'Cancel',
			IsVisible: false,
			EvClick: () =>
			{
				this._CurrentEvent = {Round: this._Round} as MMAEvent;
				this.showScreen1();
			}
		});


		this._historyNode = NP.createNode(eventInfoNode, 'events-history');

		this.showScreen1();

		//this._restoreData();
	}





	showBlockDialog = (blockerSettings: IUserInfo): boolean => {

		if (!blockerSettings)
			return false;

		let blocker: UserInfo = new UserInfo(blockerSettings);
		let curUser = NP.getCurrentUser();
		let isYou = curUser.getKey() === blocker.getKey();
		let emailPart = !isYou ? NP.escapeHTML(`<${blocker.getEmail()}>`) : '';
		let unlockPart = isYou ? `<br />${NP.RM.getString('UnlockQuestion')}` : '';
		let dlg = new Dialog({
			ShowHeader: true,
			Caption: NP.RM.getString('Error'),
			Content: `${NP.RM.getString('BattleLockMessage')}${blocker.getViewName()}${emailPart}${unlockPart}`,
			AutoDestroy: true,
			ShowButtons: true,
			EvOkButtonClick: isYou ? this.onBlockDialogOkButtonClick : undefined,
		});
		if (!isYou)
			dlg.getCancelButton().setIsVisible(false);
		dlg.show();
		return true;
	};

	onBlockDialogOkButtonClick = () =>
	{
		if (this._Battle)
		{
			ServerAPI.post(`/battle/${this._Battle.Id}/endEditBattleData`).then(() =>
			{
				NP.editingBattleId = null;
				this.show();
			});
			window.clearInterval(this._CheckEditLockTimer);
		}
	};

	async show()
	{
		if (this._Battle)
		{
			await ServerAPI.post(`/battle/${this._Battle.Id}/startEditBattleData`)
			super.show();
			//.then((blocker: IUserInfo) =>
			// 	{
			// 		if (this.showBlockDialog(blocker))
			// 			return;
			//
			// 		NP.editingBattleId = this._Battle.Id;
			// 		const checkInterval = 10000;
			// 		super.show();
			// 		if (this._CheckEditLockTimer != null)
			// 			window.clearInterval(this._CheckEditLockTimer);
			// 		this._CheckEditLockTimer = window.setInterval(() =>
			// 		{
			// 			ServerAPI.post(`/battle/${this._Battle.Id}/checkIsBattleDataLocked`).then((isLocked: boolean) =>
			// 			{
			// 				if (!isLocked)
			// 				{
			// 					ServerAPI.post(`/battle/${this._Battle.Id}/startEditBattleData`)
			// 				}
			// 			});
			// 		}, checkInterval);
			//
			// 		this._restoreData();
			// 	});
			// }
		}
	}

	hide()
	{
		if (this._Battle)
		{
			ServerAPI.post(`/battle/${this._Battle.Id}/endEditBattleData`).then(() =>
			{
				NP.editingBattleId = null;
			});
			window.clearInterval(this._CheckEditLockTimer);
		}
		super.hide();
	}




	//восстановить последний сохраненный раунд, отрезок времени
	_restoreData()
	{
		ServerAPI.get(`/mma/getBattleEvents/${this._Battle.Id}`).then((res: MMAEvent[]) =>
		{
			if (res.length > 0)
			{
				this._Round = res[res.length - 1].Round;
				this._LastEditedRound = this._Round;
				this.setCaption(NP.RM.getString('BattleStatistics') + " (" + res.length + " " + NP.RM.getString('Records') + ")");
				this._removeLastEvBtn.setIsVisible(true);
				this._canNextRound = true;

				res.filter(ev => ev.Round == this._Round).forEach(ev =>
				{

					let lastEv = this._lastHistoryEvent || {} as MMAEvent;

					if (!ev.GroundStart && lastEv.GroundStart)
						this.createTempHistoryRow('G-' + this.removeHours(this._lastHistoryEvent.GroundEnd));

					if (!ev.GrappleStart && lastEv.GrappleStart)
						this.createTempHistoryRow('C-' + this.removeHours(this._lastHistoryEvent.GrappleEnd));

					this.createHistoryRow(ev);


					if (ev.GroundStart && !lastEv.GroundStart)
						this.createTempHistoryRow('G+' + this.removeHours(ev.GroundStart));


					if (ev.GrappleStart && !lastEv.GrappleStart)
						this.createTempHistoryRow('C+' + this.removeHours(ev.GrappleStart));


					this._lastHistoryEvent = ev;
				});

				this._CurrentTime = '00:00';

				if (this._lastHistoryEvent.GrappleEnd)
				{
					this._CurrentTime = this.removeHours(this._lastHistoryEvent.GrappleEnd);
					this.createTempHistoryRow('C-' + this._CurrentTime);
				}

				if (this._lastHistoryEvent.GroundEnd)
				{
					this._CurrentTime = this.removeHours(this._lastHistoryEvent.GroundEnd);
					this.createTempHistoryRow('G-' + this._CurrentTime);
				}
				this.scrollHistory();

				this._lastHistoryEvent = null;
			}

			this._refreshHeader();
			this._CurrentEvent = {Round: this._Round} as MMAEvent;
		});
	}

	private scrollHistory()
	{
		this._historyNode.scrollTop = this._historyNode.scrollHeight;
	}


	removeHours(time: string)
	{
		if (time)
		{
			let arr = time.split(":");
			if (arr.length == 3)
				return arr[1] + ":" + arr[2];
			else
				return time;
		}
	}

	createPunches(parentNode: HTMLElement)
	{
		let strikeRedSectionRow1 = NP.createNode(parentNode, 'event-info__row'),
			 strikeRedSectionRow2 = NP.createNode(parentNode, 'event-info__row'),
			 strikeRedSectionRow3 = NP.createNode(parentNode, 'event-info__row'),
			 strikeRedSectionRow4 = NP.createNode(parentNode, 'event-info__row');

		let onClick = (btn: Button) =>
		{
			this._CurrentEvent.ActionAthleteId = parentNode == this._strikeRed ? this._Battle.Red : this._Battle.Blue;
			this._CurrentEvent.Action = btn.getValue();
			this._CurrentEvent.AnswerAthleteId = parentNode == this._strikeBlue ? this._Battle.Red : this._Battle.Blue;

			switch (btn.getValue())
			{
				case 'Takedown':
				case 'Transition':
					this.showScreen3();
					break;
				case 'Control':
					this.showInputTimeDlg('StartTime2', null, (value: string) =>
					{
						this._CurrentEvent.GrappleStart = this._GrappleStart = value;
						this._CurrentEvent.Answer = "Hit";
						this._exitGrappleBtn.setIsVisible(true);
						this.endEvent();
					});
					break;
				default:
					this.showScreen2();
					break;
			}
		};


		return [
			new Button({
				Content: NP.RM.getString('Punch'),
				Value: 'Punch',
				ParentNode: strikeRedSectionRow1,
				Class: 'app-button--outlined event-info__btn',
				EvClick: onClick
			}),
			new Button({
				Content: NP.RM.getString('Kick'),
				Value: 'Kick',
				ParentNode: strikeRedSectionRow1,
				Class: 'app-button--outlined event-info__btn',
				EvClick: onClick
			}),
			new Button({
				Content: NP.RM.getString('Elbow'),
				Value: 'Elbow',
				ParentNode: strikeRedSectionRow2,
				Class: 'app-button--outlined event-info__btn',
				EvClick: onClick
			}),
			new Button({
				Content: NP.RM.getString('Knee'),
				Value: 'Knee',
				ParentNode: strikeRedSectionRow2,
				Class: 'app-button--outlined event-info__btn',
				EvClick: onClick
			}),
			new Button({
				Content: NP.RM.getString('Takedown'),
				Value: 'Takedown',
				ParentNode: strikeRedSectionRow3,
				Class: 'app-button--outlined event-info__btn',
				EvClick: onClick
			}),
			new Button({
				Content: NP.RM.getString('Transition'),
				Value: 'Transition',
				ParentNode: strikeRedSectionRow3,
				Class: 'app-button--outlined event-info__btn',
				EvClick: onClick
			}),
			new Button({
				Content: NP.RM.getString('Submission'),
				Value: 'Submission',
				ParentNode: strikeRedSectionRow4,
				Class: 'app-button--outlined event-info__btn',
				EvClick: onClick
			}),
			new Button({
				Content: NP.RM.getString('Control'),
				Value: 'Control',
				ParentNode: strikeRedSectionRow4,
				Class: 'app-button--outlined event-info__btn',
				EvClick: onClick
			})];
	}


	createAnswers(parentNode: HTMLElement)
	{
		//Блок, Нырок, Уклон, Работа ног, Попал, Захват.
		let row1 = NP.createNode(parentNode, 'event-info__row'),
			 row2 = NP.createNode(parentNode, 'event-info__row'),
			 row3 = NP.createNode(parentNode, 'event-info__row');

		let onClick = (btn: Button) =>
		{
			this._CurrentEvent.Answer = btn.getValue();
			this.endEvent();
		};

		return [
			new Button({
				Content: NP.RM.getString('Block'),
				Value: 'Block',
				ParentNode: row1,
				Class: 'app-button--outlined event-info__btn',
				EvClick: onClick
			}),
			new Button({
				Content: NP.RM.getString('Bobbing'),
				Value: 'Bobbing',
				ParentNode: row1,
				Class: 'app-button--outlined event-info__btn',
				EvClick: onClick
			}),
			new Button({
				Content: NP.RM.getString('Slip'),
				Value: 'Slip',
				ParentNode: row2,
				Class: 'app-button--outlined event-info__btn',
				EvClick: onClick
			}),
			new Button({
				Content: NP.RM.getString('Footwork'),
				Value: 'Footwork',
				ParentNode: row2,
				Class: 'app-button--outlined event-info__btn',
				EvClick: onClick
			}),
			new Button({
				Content: NP.RM.getString('Hit'),
				Value: 'Hit',
				ParentNode: row3,
				Class: 'app-button--outlined event-info__btn',
				EvClick: onClick
			}),
			new Button({
				Content: NP.RM.getString('Grapple'),
				Value: 'Grapple',
				ParentNode: row3,
				Class: 'app-button--outlined event-info__btn',
				EvClick: onClick
			})
		];
	}


	createScreen2Buttons(parentNode: HTMLElement)
	{
		let row1 = NP.createNode(parentNode, 'event-info__row'),
			 row2 = NP.createNode(parentNode, 'event-info__row'),
			 row3 = NP.createNode(parentNode, 'event-info__row'),
			 row4 = NP.createNode(parentNode, 'event-info__row flex-column');

		let cb1: CheckBox, cb2: CheckBox;
		let exAction: string = null;

		let onClick = (btn: Button) =>
		{
			this._CurrentEvent.Zone = btn.getValue();
			if (this._CurrentEvent.Action == 'Submission')
				this.showScreen3();
			else
			{
				if (exAction)
				{
					if (exAction == 'Knockdown')
					{
						//переход в партер, типа сбил с ног
						this.showInputTimeDlg(null, null, (value: string) =>
						{
							this.doEndControl(value);
							this.saveCurrentEvents();
							this._exitGroundBtn.setIsVisible(true);
							this._CurrentEvent.GroundStart = this._GroundStart = value;
							this._CurrentEvent.Answer = exAction;

							cb1.setChecked(false, false);
							cb2.setChecked(false, false);
							exAction = null;
							this.endEvent();
						});
					}
					else
					{
						this._CurrentEvent.Answer = exAction;
						cb1.setChecked(false, false);
						cb2.setChecked(false, false);
						exAction = null;
						this.endEvent();
					}
				}
				else
					this.showScreen4();
			}
		};

		return [
			new Button({
				Content: "P1",
				Value: 'P1',
				ParentNode: row1,
				Class: 'app-button--outlined event-info__btn',
				EvClick: onClick
			}),
			new Button({
				Content: 'P3',
				Value: 'P3',
				ParentNode: row2,
				Class: 'app-button--outlined event-info__btn',
				EvClick: onClick
			}), new Button({
				Content: 'P2',
				Value: 'P2',
				ParentNode: row2,
				Class: 'app-button--outlined event-info__btn',
				EvClick: onClick
			}),
			new Button({
				Content: 'P4',
				Value: 'P4',
				ParentNode: row2,
				Class: 'app-button--outlined event-info__btn',
				EvClick: onClick
			}),
			new Button({
				Content: 'P5',
				Value: 'P5',
				ParentNode: row3,
				Class: 'app-button--outlined event-info__btn',
				EvClick: onClick
			}),
			new Button({
				Content: 'P6',
				Value: 'P6',
				ParentNode: row3,
				Class: 'app-button--outlined event-info__btn',
				EvClick: onClick
			}),
			cb1 = new CheckBox({
				Content: NP.RM.getString('CriticalPunch'),
				ParentNode: row4,
				EvCheckedChanged: () =>
				{
					cb2.setChecked(false, false);
					exAction = cb1.getChecked() ? 'CriticalPunch' : null
				}
			}),
			cb2 = new CheckBox({
				Content: NP.RM.getString('Knockdown2'),
				ParentNode: row4,
				Data: 'Knockdown',
				EvCheckedChanged: () =>
				{
					cb1.setChecked(false, false);
					exAction = cb2.getChecked() ? 'Knockdown' : null
				}
			})];
	}

	createScreen3Buttons(parentNode: HTMLElement)
	{
		return [
			new Button({
				Content: NP.RM.getString('Success'),
				Value: 'Success',
				Width: 100,
				ParentNode: NP.createNode(parentNode, 'event-info__row'),
				Class: 'app-button--outlined event-info__btn',
				EvClick: () =>
				{
					if (this._CurrentEvent.Action == 'Submission')
					{
						this._CurrentEvent.Answer = 'Hit';
						this.endEvent();
						this._setBoutEnd();
					}
					else
						this.showInputTimeDlg(null, null, (value: string) =>
						{
							let isParterStart = this._CurrentEvent.Action == 'Takedown' || this._CurrentEvent.Action == 'Transition';
							if (isParterStart)
							{
								this.doEndControl(value);
								this._exitGroundBtn.setIsVisible(true);
								this._CurrentEvent.GroundStart = this._GroundStart = value;
							}
							else
							{
								this._exitGrappleBtn.setIsVisible(true);
								this._CurrentEvent.GrappleStart = this._GrappleStart = value;
							}

							//смена позиции, надо сохранить предыдущие события
							this.saveCurrentEvents();

							this._CurrentEvent.Answer = 'Hit';
							this.endEvent();
						});
				}
			}),
			new Button({
				Content: NP.RM.getString('Unsuccessfully'),
				Value: 'Unsuccessfully',
				Width: 100,
				ParentNode: NP.createNode(parentNode, 'event-info__row'),
				Class: 'app-button--outlined event-info__btn',
				EvClick: () =>
				{
					this._CurrentEvent.Answer = 'Miss';
					this.endEvent();
				}
			})];
	}


	_refreshHeader()
	{
		let type = '';
		if (this._GroundStart)
			type = NP.RM.getString('Ground');

		if (this._GrappleStart)
			type += ' ' + NP.RM.getString('Control');

		if (!type)
			type = NP.RM.getString('Distance');
		this._roundLabel.setContent(NP.RM.getString('Round') + ' ' + this._Round + " (<b>" + type + "</b>)");
	}


	setVisCancelButton(value: boolean)
	{
		this._nextRoundBtn.setIsVisible(!value);
		this._boutEndBtn.setIsVisible(!value);
		this._removeLastEvBtn.setIsVisible(!value);
		this._saveBtn.setIsVisible(!value);
		this._canceleBtn.setIsVisible(value);
	}

	hideAllScreens()
	{
		NP.hide([this._strikeRed, this._strikeBlue, this._screen2Red, this._screen2Blue, this._screen3Blue, this._screen3Red, this._answerRed, this._answerBlue]);
	}

	showScreen1()
	{
		this.hideAllScreens();
		NP.show([this._strikeRed, this._strikeBlue]);

		if (!this._GroundStart && !this._GrappleStart)
		{
			NP.setIsVisible(this._strikeRedButtons, true);
			NP.setIsVisible(this._strikeBlueButtons, true);
		}
		else
		{
			let arr = [...this._strikeBlueButtons, ...this._strikeRedButtons];

			NP.setIsVisible(arr.filter(btn => btn.getValue() == 'Takedown' || btn.getValue() == 'Transition'), !this._GroundStart);
			NP.setIsVisible(arr.filter(btn => btn.getValue() == 'Control'), !this._GrappleStart);
		}

		this.setVisCancelButton(false);
	}

	showScreen2()
	{
		this.hideAllScreens();
		NP.show(this._CurrentEvent.ActionAthleteId == this._Battle.Red ? this._screen2Blue : this._screen2Red);

		NP.setIsVisible([...this._screen2RedButtons, ...this._screen2BlueButtons]
			 .filter(btn => btn instanceof CheckBox || btn.getValue() == 'P2'), this._CurrentEvent.Action != 'Submission');

		NP.setIsVisible([...this._screen2RedButtons, ...this._screen2BlueButtons]
			 .filter(btn => btn.getData() == 'Knockdown'), !this._GroundStart && this._CurrentEvent.Action != 'Submission');

		this.setVisCancelButton(true);
	}

	showScreen3()
	{
		this.hideAllScreens();
		NP.show(this._CurrentEvent.ActionAthleteId == this._Battle.Red ? this._screen3Blue : this._screen3Red);
		this.setVisCancelButton(true);
	}

	showScreen4()
	{
		this.hideAllScreens();
		NP.show(this._CurrentEvent.ActionAthleteId == this._Battle.Red ? this._answerBlue : this._answerRed);
		this.setVisCancelButton(true);
	}

	endEvent()
	{
		this._canNextRound = true;
		this._CurrentBattleEvents.push(this._CurrentEvent);
		this._displayBattleEventInHistory(this._CurrentEvent);
		this.showScreen1();

		this._CurrentEvent = {
			Round: this._Round,
			GrappleStart: this._GrappleStart,
			GroundStart: this._GroundStart
		} as MMAEvent;

		this._removeLastEvBtn.setIsVisible(true);
		this._refreshHeader();

		this.saveCurrentEvents();
	}

	_onCancelButtonClick()
	{
		if (this._CurrentBattleEvents.length > 0)
			NP.showConfirm({
				Content: NP.RM.getString('CloseBattleStatisticsConf'),
				EvOkButtonClick: () =>
				{
					super._onCancelButtonClick();
				}
			});
		else
			super._onCancelButtonClick();
	}

	_displayBattleEventInHistory(ev: MMAEvent)
	{
		let {redEvent, blueEvent} = this.createHistoryRow(ev);


		let lastEv = this._lastHistoryEvent || {} as MMAEvent;

		if (ev.GroundStart && !lastEv.GroundStart)
			this.createTempHistoryRow('G+' + this.removeHours(ev.GroundStart));
		else if (!ev.GroundStart && lastEv.GroundStart)
			this.createTempHistoryRow('G-' + this.removeHours(this._lastHistoryEvent.GroundEnd));

		if (ev.GrappleStart && !lastEv.GrappleStart)
			this.createTempHistoryRow('C+' + this.removeHours(ev.GrappleStart));
		else if (!ev.GrappleStart && lastEv.GrappleStart)
			this.createTempHistoryRow('C-' + this.removeHours(this._lastHistoryEvent.GrappleEnd));

		this.scrollHistory();

		this._lastHistoryEvent = ev;
		return [redEvent, blueEvent];
	}


	private createHistoryRow(ev: MMAEvent)
	{
		let row = NP.createNode(this._historyNode, 'events-history__row', null),
			 redEvent = NP.createNode(row, 'events-history__row__item'),
			 blueEvent = NP.createNode(row, 'events-history__row__item');

		let an = ev.Answer ? ev.Answer : "Unsuccessfully";

		let redKey = (ev.ActionAthleteId == this._Battle.Red ? ev.Action : an),
			 blueKey = (ev.ActionAthleteId == this._Battle.Blue ? ev.Action : an);

		let length = document.body.offsetWidth <= 480 ? 1 : 3;

		redEvent.innerText = redKey.substring(0, length);
		blueEvent.innerText = blueKey.substring(0, length);

		redEvent.setAttribute("title", NP.RM.getString(redKey));
		blueEvent.setAttribute("title", NP.RM.getString(blueKey));
		return {redEvent, blueEvent};
	}

	private createTempHistoryRow(time: string)
	{
		let row = NP.createNode(this._historyNode, 'events-history__row', null);
		row.setAttribute("is_temp", "true");

		if (time.indexOf('G-') > -1)
			row.setAttribute('type', 'G-');
		if (time.indexOf('C-') > -1)
			row.setAttribute('type', 'C-');

		row.innerText = time;

		let arr = time
			 .replace('G+', '')
			 .replace('G-', '')
			 .replace('C+', '')
			 .replace('C-', '')
			 .split(":");
		let seconds = parseInt(arr[0]) * 60 + parseInt(arr[1]);
		row.setAttribute('seconds', seconds);
	}

	showInputTimeDlg(captionRK: string, value: string, callback: Function)
	{
		let dlg: Dialog;
		(dlg = new Dialog({
			ShowHeader: true,
			AutoDestroy: true,
			Caption: NP.RM.getString(captionRK || 'StartTime2'),
			Content: new TimeEdit({
				Mode: TimeEditMode.MinutesSeconds,
				Value: value || this._CurrentTime,
				EvEnter: () =>
				{
					let v = dlg.getContent().getValue();
					let cDate = new Date('12/12/2019 00:' + this._CurrentTime);

					if (/\d\d:\d\d/.test(v) && cDate < new Date('12/12/2019 00:' + v))
					{
						this._CurrentTime = v;
						callback(v);
						dlg.hide();
					}
				}
			}),
			EvOkButtonClick: (dlg: Dialog, e: DialogCloseEventArgs) =>
			{
				let v = dlg.getContent().getValue();
				let cDate = new Date('12/12/2019 00:' + this._CurrentTime);

				if (/\d\d:\d\d/.test(v) && cDate < new Date('12/12/2019 00:' + v))
				{
					this._CurrentTime = v;
					callback(v);
				}
				else
					e.IsCancelClose = true;
			}
		})).show();
		dlg.getContent().focus();
	}


	_clearHistory()
	{
		this._historyNode.innerHTML = '';
	}

	saveCurrentEvents()
	{
		if (this._CurrentBattleEvents.length)
		{
			this._CurrentBattleEvents.forEach(ev =>
			{
				if (ev.GroundStart)
					ev.GroundStart = '00:' + ev.GroundStart;
				if (ev.GroundEnd)
					ev.GroundEnd = '00:' + ev.GroundEnd;
				if (ev.GrappleStart)
					ev.GrappleStart = '00:' + ev.GrappleStart;
				if (ev.GrappleEnd)
					ev.GrappleEnd = '00:' + ev.GrappleEnd;
			});
			ServerAPI.post(`/mma/${this._Battle.Id}/addBattleEvents`, this._CurrentBattleEvents)
			this._CurrentBattleEvents = [];

			this._canNextRound = true;
		}
	}

	_setBoutEnd()
	{
		if (this._GrappleStart || this._GroundStart)
			this.endGroundAndGrapple(() =>
			{
				ServerAPI.post(`/battle/${this._Battle.Id}/updateEndTimeBattle?endTime=${this._CurrentTime}`);
				this.hide();
			});
		else
		{
			this.showInputTimeDlg('TimeBoutEnd', this.getTime(this._Battle.RoundLength), () =>
			{
				this.saveCurrentEvents();
				this._Battle.EndTime = '00:' + this._CurrentTime;
				ServerAPI.post(`/battle/${this._Battle.Id}/updateEndTimeBattle?endTime=${this._CurrentTime}`);
				this.hide();
			});
		}
	}

	private doNextRound()
	{
		this._clearHistory();
		this._nextRoundBtn.setEnabled(this._Round < this._MaxRound);

		if (this._Round < this._LastEditedRound)
		{
			this._Round = this._LastEditedRound;
		}
		else
		{
			this._Round += 1;
			this._LastEditedRound = this._Round;
		}
		this._CurrentTime = '00:00';
		this._CurrentEvent.Round = this._Round;
		this._refreshHeader();
		this._canNextRound = false;
	}

	getTime(minutes: number)
	{
		let v = minutes;
		if (v < 10)
		//@ts-ignore
			v = '0' + v;
		return v + ':00';
	}

	_setNextRound()
	{
		if (this._canNextRound)
		{
			if (this._GrappleStart || this._GroundStart)
			{
				this.endGroundAndGrapple(() => this.doNextRound(), this.getTime(this._Battle.RoundLength));
			}
			else
			{
				this.saveCurrentEvents();
				this.doNextRound();
			}

		}
	}

	endGroundAndGrapple(callback?: Function, endTime?: string)
	{
		this.showInputTimeDlg('EndTimeOfGround', endTime, (value: string) =>
		{
			this._CurrentBattleEvents.forEach(ev =>
			{
				if (ev.GroundStart && !ev.GroundEnd)
					ev.GroundEnd = value;

				if (ev.GrappleStart && !ev.GrappleEnd)
					ev.GrappleEnd = value;
			});

			if (this._CurrentEvent.GroundStart)
				this.createTempHistoryRow('G-' + value);

			if (this._CurrentEvent.GrappleStart)
				this.createTempHistoryRow('C-' + value);

			this._lastHistoryEvent = null;

			this.scrollHistory();

			this._exitGrappleBtn.setIsVisible(false);
			this._exitGroundBtn.setIsVisible(false);

			this._GroundStart = null;
			this._GroundEnd = null;
			this._GrappleEnd = null;
			this._GrappleStart = null;

			this._CurrentEvent.GroundStart = null;
			this._CurrentEvent.GrappleStart = null;

			this.saveCurrentEvents();
			this.showScreen1();
			this._refreshHeader();
			if (callback)
				callback();
		});
	}

	endControl(callback?: Function)
	{
		this.showInputTimeDlg('EndTimeOfControl', null, (value: string) =>
		{
			this.doEndControl(value);
			this.showScreen1();
			this._refreshHeader();
			if (callback)
				callback();
		});
	}

	doEndControl(endTime: string)
	{
		if (this._GrappleStart)
		{
			this._CurrentBattleEvents.forEach(ev =>
			{
				if (ev.GrappleStart)
					ev.GrappleEnd = endTime;
			});

			this._lastHistoryEvent = {
				...this._lastHistoryEvent
			};

			this._lastHistoryEvent.GrappleStart = null;
			this._lastHistoryEvent.GrappleEnd = null;

			this.createTempHistoryRow('C-' + endTime);
			this.scrollHistory();

			this._CurrentEvent.GrappleStart = null;

			this._GrappleEnd = null;
			this._GrappleStart = null;

			this._exitGrappleBtn.setIsVisible(false);

			if (!this._GroundStart)
				this.saveCurrentEvents();
		}
	}

	/**
	 *
	 * @param ev новое последнее событие
	 */
	private restoreStateByEvent(ev: MMAEvent, removedNode: HTMLElement)
	{
		if (!ev)
			ev = {} as MMAEvent;


		if (ev.GroundStart && !this._GroundStart && removedNode && removedNode.getAttribute("type") == 'G-')
		{
			this._exitGroundBtn.setIsVisible(true);
			this._CurrentEvent.GroundStart = this._GroundStart = this.removeHours(ev.GroundStart);
		}

		if (!ev.GroundStart && this._GroundStart)
		{
			this._exitGroundBtn.setIsVisible(false);
			this._GroundEnd =
				 this._CurrentEvent.GroundStart = this._GroundStart = null;
		}


		if (ev.GrappleStart && !this._GrappleStart && removedNode && removedNode.getAttribute("type") == 'C-')
		{
			this._exitGrappleBtn.setIsVisible(true);
			this._CurrentEvent.GrappleStart = this._GrappleStart = this.removeHours(ev.GrappleStart);
		}

		if (!ev.GrappleStart && this._GrappleStart)
		{
			this._exitGrappleBtn.setIsVisible(false);
			this._GroundEnd =
				 this._CurrentEvent.GrappleStart = this._GrappleStart = null;
		}


		if (ev.Round && ev.Round != this._Round)
		{
			this._CurrentEvent.Round =
				 this._LastEditedRound =
					  this._Round = ev.Round;
		}



		this._refreshHeader();
		this.showScreen1();
	}

	private removeLastEvent()
	{
		let removedNode = this._historyNode.childNodes[this._historyNode.childNodes.length - 1] as HTMLElement;
		if (this._CurrentBattleEvents.length)
		{
			NP.removeFromArrayByIndex(this._CurrentBattleEvents, this._CurrentBattleEvents.length - 1);
			this._lastHistoryEvent = this._CurrentBattleEvents[this._CurrentBattleEvents.length - 1];

			if (!this._lastHistoryEvent)
				ServerAPI.get(`/mma/getLastEvent/${this._Battle.Id}?round=${this._Round}`).then((ev: MMAEvent) =>
				{
					this.restoreStateByEvent(ev, removedNode);
					this._lastHistoryEvent = ev;
				});
			else
			{
				this.restoreStateByEvent(this._lastHistoryEvent, removedNode);
			}
		}
		else
			ServerAPI.post(`/mma/removeLastEvent/${this._Battle.Id}?round=${this._Round}`).then((ev: MMAEvent) =>
			{
				this.restoreStateByEvent(ev, removedNode);
				this._lastHistoryEvent = ev;
			});

		this.checkTempNode();
		this.checkTempNode();

		if (this._historyNode.childNodes.length)  //удаляем реальную вершину
			NP.removeFromParent(this._historyNode.childNodes[this._historyNode.childNodes.length - 1]);
		this.refreshCurrentTime();
	}

	refreshCurrentTime()
	{
		this._CurrentTime = '00:00';
		let nodes = this._historyNode.querySelectorAll('.events-history__row[is_temp="true"]');

		let max = 0;
		for (let i = 0; i < nodes.length; i++)
		{
			let v = parseInt(nodes[i].getAttribute('seconds'));
			if (isNaN(v))
				continue;

			if (max < v)
				max = v;
		}

		if (max > 0)
		{
			let minutes = Math.floor(max / 60),
				 seconds = max % 60;

			let strM = minutes >= 10 ? minutes + '' : '0' + minutes,
				 strS = seconds >= 10 ? seconds + '' : '0' + seconds;

			this._CurrentTime = strM + ':' + strS;
		}
	}

	checkTempNode()
	{
		let node = this._historyNode.childNodes[this._historyNode.childNodes.length - 1] as HTMLElement;

		if (node && node.getAttribute("is_temp"))
			NP.removeFromParent(node);
	}
}
